import { Link } from 'gatsby'
import React, { useState, useEffect } from 'react'
import { Container, Navbar, Nav, Row, Col } from 'react-bootstrap'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import { getQuality } from '@helpers/helper.rendering'
import { getFakeAddress } from '@helpers/helper.developments'
import { RealEstateDataPageComponentData } from 'types'
import { Toaster } from 'react-hot-toast'
import $ from 'jquery'

const isBrowser = typeof window !== 'undefined'

const HeaderFloatDynamic = ({
  developmentID,
  propertyID,
  global_data,
  hidden,
  spanText,
  backgroundSecondary,
  height,
  customFontSize,
  contentColorCustom,
  backgroundHexa,
  titleHexa,
}: {
  developmentID: string
  propertyID: string
} & RealEstateDataPageComponentData) => {
  const [open, setOpen] = useState<boolean>(false)
  const logo = global_data.logo
  const { divisionPath } = global_data
  const [scrollTop, setScrollTop] = useState<number>(0)
  const [scrolling, setScrolling] = useState<boolean>(false)

  const [isScrolled, setIsScrolled] = useState(false)

  const [active, setActive] = useState('')

  const [navItems, setNavItems] = useState<string[]>([])

  const { data: allDevelopmentData, isLoading: isLoadingDevelopments } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )
  const { data: allPropertyData, isLoading: isLoadingProperties } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  useEffect(() => {
    const onScroll = (e: any) => {
      setScrollTop(e.target.documentElement.scrollTop)
      setScrolling(e.target.documentElement.scrollTop > scrollTop)
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [scrollTop])

  const scrollTo = (section: any): void => {
    var header2El = document.getElementById('dynamic_header_2')
    var position = $('#' + section)?.offset()?.top
    var body = $('html, body')
    const positionCurrent = $('body').scrollTop()!
    body
      .stop()
      .animate(
        { scrollTop: position! + positionCurrent - (header2El ? 200 : 90) },
        500,
        'swing',
        function () {},
      )
  }

  const handleClickNav = (sectionToScroll: string, e: any) => {
    scrollTo(sectionToScroll)
    e.preventDefault()
    setOpen(false)
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
  }

  useEffect(() => {
    setNavItems([])
    if (allDevelopmentData || allPropertyData) {
      setTimeout(function () {
        // Coloca aquí el código que recopila los IDs de los sections
        const sections = document.querySelectorAll('section')
        const sectionIds: any = []

        sections.forEach((section) => {
          const sectionId = section.id
          if (sectionId) {
            sectionIds.push(sectionId)
          }
          setNavItems(sectionIds)
        })
      }, 100)
      if (isBrowser) {
        const body = document.querySelector('body') as HTMLElement
        const content = document.querySelector('#dynamic_header') as HTMLElement
        const header = document.querySelector('#dynamic_header_2') as HTMLElement
        if (header?.clientHeight > 0) {
          content.style.top = header?.clientHeight + 'px'
        } else {
          content.style.top = '0px'
        }
        // })
        // body.style.paddingTop = header?.clientHeight + content?.clientHeight + 'px'
      }
    }
  }, [allDevelopmentData, allPropertyData])
  const elemento = document.getElementById('gatsby-focus-wrapper')
  setTimeout(() => {}, 200)

  // Función para determinar el elemento visible en el viewport
  function elementoVisible() {
    let elementoVisible: string = ''
    if (allDevelopmentData || allPropertyData) {
      const elementos = document.querySelectorAll('section')
      elementos.forEach((elemento) => {
        const rect = elemento.getBoundingClientRect()
        // Verificar si el elemento está en la vista
        if (elemento?.id) {
          if (
            // rect.top >= 0 &&
            rect.bottom - 250 <=
            (window?.innerHeight || document.documentElement?.clientHeight)
          ) {
            elementoVisible = elemento?.id.toString()
          }
        }
      })

      setActive(elementoVisible)
    }
  }

  const NavEl = (desktop: boolean = true) => (
    <>
      <Nav
        className={`nav-menu ${
          desktop ? 'd-flex justify-content-between w-auto' : 'd-flex flex-column w-100'
        }`}
      >
        {navItems.map((idName, index) => (
          <Nav.Item
            key={index}
            onClick={() =>
              document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
            }
            style={{
              color: contentColorCustom ? titleHexa : '',
              borderColor: contentColorCustom ? titleHexa : '',
            }}
            className={active.toLowerCase() === idName.toLowerCase() ? ' active ' : ''}
          >
            <a
              style={{
                color: contentColorCustom ? titleHexa : '',
                borderColor: contentColorCustom ? titleHexa : '',
              }}
              onClick={(e) => handleClickNav(idName, e)}
              className={
                'nav-link  ' +
                (spanText || 'text-uppercase ') +
                (active.toLowerCase() === idName.toLowerCase() ? ' active ' : '')
              }
            >
              {idName.replaceAll('-', ' ')}
            </a>
          </Nav.Item>
        ))}
        {!hidden ? (
          <Nav.Item>
            <Link
              to={
                allDevelopmentData
                  ? (divisionPath ?? '') + '/emprendimientos'
                  : allPropertyData?.development
                  ? (divisionPath ?? '') +
                    '/emprendimiento/' +
                    getFakeAddress(allPropertyData?.development!)
                      ?.replaceAll(' ', '-')
                      ?.replaceAll('/', '-')
                      ?.toLowerCase() +
                    '/' +
                    allPropertyData?.development?.id
                  : '/'
              }
              className={
                'nav-link return-dev ' +
                (spanText === 'text-uppercase' || !spanText ? 'text-uppercase' : '')
              }
              onClick={() => {
                setOpen(false)
                document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
                document.getElementById('gatsby-focus-wrapper')?.classList.remove('top-custom-body')
              }}
            >
              Volver a{' '}
              {allDevelopmentData
                ? 'emprendimientos'
                : allPropertyData?.development
                ? allPropertyData.development.name.length > 15
                  ? allPropertyData.development.name.substring(0, 15) + '...'
                  : allPropertyData.development.name
                : 'Inicio'}
            </Link>
          </Nav.Item>
        ) : (
          <span
            className="d-none nav-item"
            aria-hidden="true"
          ></span>
        )}
      </Nav>
    </>
  )

  if (isBrowser) {
    const body = document.querySelector('body') as HTMLElement

    body.addEventListener('scroll', elementoVisible)
  }

  const staticBody = () => {
    var body = document.getElementsByTagName('html')[0]

    body.classList.toggle('overflow-hidden')
  }

  function getHeight() {
    if (isBrowser) {
      if (screen.width < 992) {
        return height?.mobile
      } else {
        return height?.desktop
      }
    }
  }

  return (
    <header
      id="dynamic_header"
      style={{ height: getHeight() ? getHeight() + 'px' : '' }}
      className={`${isLoadingDevelopments || isLoadingProperties ? ' skeleton ' : ''} a blur ${
        open ? 'opened' : ''
      } ${isScrolled ? 'position-sticky' : 'position-sticky'} ${
        backgroundSecondary ? 'secondary-colors-nav' : ''
      } `}
    >
      <Navbar
        sticky="top"
        className="brand"
        style={{ backgroundColor: contentColorCustom ? backgroundHexa : '' }}
      >
        <Container fluid>
          <Row className="justify-content-center align-items-center w-100">
            <Col
              lg={3}
              xs={6}
              className="justify-content-start"
            >
              <Toaster
                toastOptions={{
                  className: 'toast-className',
                  style: {
                    maxWidth: 'fit-content',
                  },
                }}
              />
              <Navbar.Brand
                aria-label="Enlace inicio"
                href="/"
              >
                {allDevelopmentData ? (
                  <img
                    alt="logo-header"
                    src={
                      getQuality(
                        allDevelopmentData?.photos.find(
                          (element: { description: string }) => element.description === 'logo',
                        ),
                      ) || logo
                    }
                    height={(parseInt(getHeight() || '50') * (customFontSize || 60)) / 100}
                    width={'150'}
                    className="d-inline-block align-top me-2 logo-header"
                  />
                ) : allPropertyData ? (
                  <img
                    alt="logo-header"
                    src={
                      getQuality(
                        allPropertyData?.development?.photos.find(
                          (element: { description: string }) => element.description === 'logo',
                        ),
                      ) || logo
                    }
                    height={'50'}
                    width={'150'}
                    className="d-inline-block align-top me-2 logo-header"
                  />
                ) : (
                  <img
                    alt="logo-header"
                    src={logo}
                    height={'50'}
                    width={'150'}
                    className="d-inline-block align-top me-2 logo-header"
                  />
                )}
              </Navbar.Brand>
            </Col>
            <Col
              lg={9}
              className="text-right d-lg-flex justify-content-end d-none desktop-menu"
            >
              {NavEl()}
            </Col>
            {/* Nav Menu col mobile */}
            <Col className="text-right d-flex align-items-center justify-content-end d-lg-none">
              <button
                id="toggle-nav"
                aria-label="toggle"
                onClick={() => {
                  setOpen(!open)
                  staticBody()
                }}
              >
                <div className="d-flex align-items-center">
                  <span className="ms-4">
                    <i></i>
                    <i></i>
                    <i></i>
                  </span>
                </div>
              </button>
            </Col>
          </Row>
          {/* Nav Content mobile */}
          <div className="nav-content mobile-menu opened d-flex align-items-center d-lg-none">
            <div
              className="background"
              style={{ backgroundColor: contentColorCustom ? backgroundHexa : '' }}
            ></div>
            <Container fluid>
              <Row>
                <Col className="align-self-center">{NavEl(false)}</Col>
              </Row>
            </Container>
          </div>
        </Container>
      </Navbar>
    </header>
  )
}

export default HeaderFloatDynamic
